import { IAppSettings } from "../model";

export const getAppSettings = async (): Promise<IAppSettings> => {
    const res = await fetch('/settings.json');
    return res.json();
}
